import { useCurrentPractice } from '../contexts/PracticeContext'
import NotFound from 'pages/errors/NotFound'

interface FinancingDevGuardProps {
	children: React.ReactNode
}

const FinancingDevGuard = ({ children }: FinancingDevGuardProps) => {
	const { currentPracticeObject, canAccessFinancingDev } = useCurrentPractice()

	// prevent page from redirecting to 404 while loading after refresh
	if (!Object.keys(currentPracticeObject).length) {
		return null
	}
	return canAccessFinancingDev ? <>{children}</> : <NotFound />
}

export default FinancingDevGuard
